import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.paleSkyBlue,
  secondaryBgColor: colors.white,
  cardRadius: '20px',
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default imageSlider;